export default function isNotEmptyArray(array: any): array is Array<any> {
  return Array.isArray(array) && !!array.length;
}
